module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cL5ZL"))).then(() => parcelRequire('ljYL6'));